import Vue from "vue";
import VueI18n from "vue-i18n";
import zh from "../lang/zh";
import en from "../lang/en";

Vue.use(VueI18n);

const messages = {
	zh,
	en,
};

const i18n = new VueI18n({
	locale: localStorage.getItem("locale") || "zh",
	fallbackLocale: "zh",
	messages,
});

export default i18n;
